import moment from 'moment';

export default {
  methods: {
    str2time(value) {
      return value ?
        moment.utc(value.substring(4), 'MMM DD YYYY HH:mm:ss GMTZZ') :
        null;
    },
    dateFmt(value) {
      return value ?
        moment.utc(value).format('DD/MM/YYYY') :
        null;
    },
    monthYearFmt(value) {
      return value ?
        moment.utc(value).format('MM/YYYY') :
        null;
    },
    ISO8601dateFmt(value) {
      return value ?
        moment.utc(value).format('YYYY-MM-DD') :
        null;
    },
  },
};

